import React from 'react';

const TextInput = ({ ...props }) => {
  return (
    <input
      {...props}
      type={props.type ?? "text"}
      className={`${props.className} 
        block w-full rounded border-0 p-2.5 ring-1 ring-gray-300 placeholder:text-gray-300 placeholder:font-regular focus:ring-2 focus:ring-gray-500 transition-all ease-in-out duration-200 disabled:bg-gray-100 disabled:text-gray-400 "
      `}
    />
  );
};

export default TextInput;
